module.exports = __webpack_public_path__ + "static/media/Page-3.981d957f.jpg";